const section6Data = [
  {
    id: 1,
    imgName: 'Section6Feature1.png',
    title: 'Multitask Calendar',
    alt: 'Multitask Calendar',
    gridClass: 'div1',
    delay: 0.4,
    description:
      'Stay on track with special calendars that highlight all the important tasks you have lined up. This integrated feature is available to both students and tutors.',
  },
  {
    id: 2,
    imgName: 'Section6Feature2.png',
    title: 'Latest News',
    alt: 'Latest News',
    gridClass: 'div2',
    delay: 0.6,
    description:
      'Students and tutors can also see the latest news of the crypto world. It will help keep them in touch with the most important changes and make classes more engaging.',
  },
  {
    id: 3,
    imgName: 'Section6Feature3.png',
    title: 'Personalized Quizzes',
    alt: 'Personalized Quizzes',
    gridClass: 'div3',
    delay: 0.8,
    description:
      "Tutors are also able to prepare personalized quizzes to check students' progress. Successful quizzes will help to get awards and increase ratings.",
  },
  {
    id: 4,
    imgName: 'Section6Feature5.png',
    title: 'Reward System',
    alt: 'Reward System',
    gridClass: 'div4',
    delay: 1.0,
    description:
      'Every student/tutor has access to their own personalized dashboard with all statistics to see their progress and other useful information.',
  },
  {
    id: 5,
    imgName: 'Section6Feature4.png',
    title: 'User Dashboard',
    alt: 'User Dashboard',
    gridClass: 'div5',
    delay: 1.2,
    description:
      'An innovative motivating system for our amazing tutors and students. Tutors can give a reward for a student’s great work via Apolo-P2P’s innovative reward strategy.',
  },
  {
    id: 6,
    imgName: 'Section6Feature6.png',
    title: 'Interactive Map',
    alt: 'Interactive Map',
    gridClass: 'div6',
    delay: 1.4,
    description:
      'As a tutor you can view a special map that can show the geography of your students. It will help you aid the students faster and more interactively.',
  },
]

export default section6Data
